import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { assertStatus } from "@mittwald/api-client-NEXT";
import { mittwaldApi } from "../../../../api/Mittwald";
import type { ExtensionInstanceBehaviors } from "./types.js";

export const apiExtensionInstanceBehaviors = (
  client: MittwaldAPIV2Client,
): ExtensionInstanceBehaviors => ({
  find: async (extensionInstanceId) => {
    const response = await client.marketplace.extensionGetExtensionInstance({
      extensionInstanceId,
    });
    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (query) => {
    const response = await client.marketplace.extensionListExtensionInstances({
      queryParameters: query,
    });
    assertStatus(response, 200);
    return {
      items: response.data,
      // todo: warten bis gefixt
      totalCount: 0, //extractTotalCountHeader(response),
    };
  },

  create: async (data) => {
    const response = await client.marketplace.extensionCreateExtensionInstance({
      data,
    });
    assertStatus(response, 201);
    return response.data;
  },

  consentToScopes: async (extensionInstanceId, data) => {
    const response = await client.marketplace.extensionConsentToExtensionScopes(
      { extensionInstanceId, data },
    );
    assertStatus(response, 204);
  },

  enable: async (extensionInstanceId) => {
    const response = await client.marketplace.extensionEnableExtensionInstance({
      extensionInstanceId,
    });
    assertStatus(response, 204);
  },

  disable: async (extensionInstanceId) => {
    const response = await client.marketplace.extensionDisableExtensionInstance(
      { extensionInstanceId },
    );
    assertStatus(response, 204);
  },

  delete: async (extensionInstanceId) => {
    const response = await client.marketplace.extensionDeleteExtensionInstance({
      extensionInstanceId,
    });
    assertStatus(response, 204);
  },

  createRetrievalKey: async (extensionInstanceId) => {
    const response = await client.marketplace.extensionCreateRetrievalKey({
      extensionInstanceId,
    });
    assertStatus(response, 200);

    return response.data;
  },

  findContract: async (extensionInstanceId) => {
    // todo: replace when available in new client
    const response =
      await mittwaldApi.extensionGetExtensionInstanceContract.request({
        path: {
          extensionInstanceId,
        },
      });
    if (response.status === 200) {
      return response.content;
    }
    //assertStatus(response, 404);
  },
  updateContract: async (extensionInstanceId) => {
    // todo: replace when available in new client
    await mittwaldApi.extensionUpdateExtensionInstanceContract.request({
      path: {
        extensionInstanceId,
      },
    });
    //assertStatus(response, 200);
  },

  terminate: async (extensionInstanceId, instantTermination) => {
    // todo: replace when available in new client
    await mittwaldApi.extensionScheduleExtensionTermination.request({
      path: {
        extensionInstanceId,
      },
      requestBody: { instantTermination },
    });
    //assertStatus(response, 200);
  },

  cancelTermination: async (extensionInstanceId) => {
    // todo: replace when available in new client
    await mittwaldApi.extensionCancelExtensionTermination.request({
      path: {
        extensionInstanceId,
      },
    });
    //assertStatus(response, 200);
  },
});
